import React from 'react'

import type { GraphElementState } from 'EditorApp/types'
import RenderedSvgElement from 'components/RenderedSvgElement'

interface Props {
  readonly element: GraphElementState
}

const GraphElement = ({ element }: Props) => {
  return (
    <RenderedSvgElement
      name="ButtonElement"
      id={element.id}
      svg={element.renderedSvg}
    />
  )
}

export default GraphElement
